import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';

import utils from '../../utils/utils';

import { connect } from 'react-redux';
import Loader from '../../components/loader';
import ErrorMessage from '../../components/errorMessage';
import ITEM_TEMPERATURE from '../../components/constants/itemTemperature';
import { useEditDeliveryDayMarketplace } from './apiHooks';
import DELIVERY_DAY_MARKETPLACE_INVENTORY_STATUS from '../../components/constants/deliveryDayMarketplaceInventoryStatus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faMinusCircle, faPlusCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

const PackerDeliveryDayMarketplaceView = ({ deliveryDayMarketplace }) => {
  const [combinedOrderItems, setCombinedOrderItems] = useState(null);

  const {
    editDeliveryDayMarketplace,
    isLoading: editLoading,
    isError: isEditError,
    error: editError,
  } = useEditDeliveryDayMarketplace(() => {});

  useEffect(() => {
    if (!deliveryDayMarketplace) {
      return;
    }

    if (deliveryDayMarketplace.combinedOrderItems?.length) {
      setCombinedOrderItems(
        deliveryDayMarketplace.combinedOrderItems.map((coi) => ({
          ...coi,
          fulfilledQuantity: coi.fulfilledQuantity != null ? coi.fulfilledQuantity : coi.orderedQuantity,
          inventoryFinished: false,
        }))
      );
    }
  }, [deliveryDayMarketplace]);

  const tempEnums = Object.keys(ITEM_TEMPERATURE).map((key) => ITEM_TEMPERATURE[key]);

  const { formatMessage } = useIntl();

  return (
    <div>
      <Loader show={editLoading} />
      {isEditError ? <ErrorMessage error={utils.getErrorMessageFromResponse(editError)} /> : ''}

      {deliveryDayMarketplace?.combinedOrderItems?.length ? (
        <div className="row m-b-6">
          <div className="col-12 m-b-3">
            {!deliveryDayMarketplace.inventoryStatus ? (
              <button
                className={`btn btn-small btn-primary m-r-2 ${editLoading ? 'btn-loading' : ''}`}
                onClick={() =>
                  editDeliveryDayMarketplace({
                    deliveryDayMarketplace: {
                      ...deliveryDayMarketplace,
                      inventoryStatus: DELIVERY_DAY_MARKETPLACE_INVENTORY_STATUS.inProgress,
                    },
                  })
                }
              >
                <FormattedMessage id={'packer.delivery.day.marketplace.inventory.cta.start'} />
              </button>
            ) : (
              ''
            )}

            {deliveryDayMarketplace.inventoryStatus !== null ? (
              <button
                className={`btn btn-small btn-danger m-r-2 ${editLoading ? 'btn-loading' : ''}`}
                onClick={() => {
                  if (
                    window.confirm(
                      formatMessage({ id: 'packer.delivery.day.marketplace.inventory.cta.cancel.confirm' })
                    )
                  ) {
                    editDeliveryDayMarketplace({
                      deliveryDayMarketplace: {
                        ...deliveryDayMarketplace,
                        inventoryStatus: null,
                      },
                    });
                  }
                }}
              >
                <FormattedMessage id={'packer.delivery.day.marketplace.inventory.cta.cancel'} />
              </button>
            ) : (
              ''
            )}
          </div>
          <div className="col-12 col-lg-10 col-lg-8">
            <div className="row">
              <div className="col-12 col-sm-4">
                <div className="p-t-3 p-b-3">
                  <strong>
                    <FormattedMessage id={'packer.delivery.day.marketplace.table.column.item'} />
                  </strong>
                </div>
              </div>
              <div className="col-6 col-sm-4">
                <div className="p-t-3 p-b-3">
                  <strong>
                    <FormattedMessage id={'packer.delivery.day.marketplace.table.column.ordered.quantity'} />
                  </strong>
                </div>
              </div>
              <div className="col-6 col-sm-4">
                <div className="p-t-3 p-b-3">
                  <strong>
                    <FormattedMessage id={'packer.delivery.day.marketplace.table.column.fulfilled.quantity'} />
                  </strong>
                </div>
              </div>
            </div>

            <div className="col-12 m-b-3">
              {deliveryDayMarketplace.combinedOrderItems.map((combinedOrderItem, itemIndex) => {
                const temperature = combinedOrderItem.item.temperature
                  ? tempEnums.find((value) => value.name === combinedOrderItem.item.temperature)
                  : null;

                const coiIndex = combinedOrderItems
                  ? combinedOrderItems.findIndex((coi) => coi.id === combinedOrderItem.id)
                  : -1;

                const setNewFulfilledValue = (newValue) => {
                  const newCombinedItems = [...combinedOrderItems];
                  newCombinedItems[coiIndex].fulfilledQuantity = newValue;
                  newCombinedItems[coiIndex].inventoryFinished = true;
                  setCombinedOrderItems(newCombinedItems);
                };

                const triggerInventoryFinished = (newValue) => {
                  const newCombinedItems = [...combinedOrderItems];
                  newCombinedItems[coiIndex].inventoryFinished = newValue;
                  setCombinedOrderItems(newCombinedItems);
                };

                const fulfilledQuantity = coiIndex >= 0 ? combinedOrderItems[coiIndex].fulfilledQuantity : null;

                return (
                  <div className="packer__delivery-day-marketplace-combined-order-item row p-t-3 p-b-3" key={itemIndex}>
                    <div className="col-12 col-sm-4 m-b-2">
                      {utils.getItemName(combinedOrderItem.item, formatMessage)} {temperature ? temperature.icon : ''}
                    </div>
                    <div className="col-4 col-sm-4 m-b-2">{combinedOrderItem.orderedQuantity}</div>
                    <div className="col-8 col-sm-4 m-b-2">
                      {deliveryDayMarketplace.inventoryStatus ===
                      DELIVERY_DAY_MARKETPLACE_INVENTORY_STATUS.inProgress ? (
                        <>
                          {fulfilledQuantity !== null ? (
                            <>
                              <FontAwesomeIcon
                                size="lg"
                                onClick={() =>
                                  fulfilledQuantity > 0 ? setNewFulfilledValue(Number(fulfilledQuantity) - 1) : 0
                                }
                                className="m-r-1"
                                icon={faMinusCircle}
                              />
                              <input
                                value={fulfilledQuantity}
                                className={`form-control d-inline-block packer__delivery-day-marketplace-combined-order-item-input ${
                                  fulfilledQuantity < combinedOrderItems[coiIndex].orderedQuantity
                                    ? 'text-danger'
                                    : fulfilledQuantity > combinedOrderItems[coiIndex].orderedQuantity
                                    ? 'text-info'
                                    : ''
                                }`}
                                type="number"
                                onChange={(e) => {
                                  const newValue = e.target.value !== '' ? Number(e.target.value) : '';
                                  setNewFulfilledValue(newValue);
                                }}
                              />
                              <FontAwesomeIcon
                                size="lg"
                                onClick={() => setNewFulfilledValue(Number(fulfilledQuantity) + 1)}
                                className="m-l-1 m-r-2"
                                icon={faPlusCircle}
                              />
                              {coiIndex >= 0 ? (
                                <>
                                  {combinedOrderItems[coiIndex].inventoryFinished ? (
                                    <FontAwesomeIcon
                                      size="lg"
                                      onClick={() => triggerInventoryFinished(false)}
                                      className="m-l-1 text-success"
                                      icon={faCheckCircle}
                                    />
                                  ) : (
                                    <FontAwesomeIcon
                                      size="lg"
                                      onClick={() => triggerInventoryFinished(true)}
                                      className="m-l-1 text-danger"
                                      icon={faTimesCircle}
                                    />
                                  )}
                                </>
                              ) : (
                                ''
                              )}
                            </>
                          ) : (
                            '-'
                          )}
                        </>
                      ) : (
                        <div
                          className={`${
                            combinedOrderItem.fulfilledQuantity != null
                              ? combinedOrderItem.fulfilledQuantity > combinedOrderItem.orderedQuantity
                                ? 'text-info'
                                : combinedOrderItem.fulfilledQuantity < combinedOrderItem.orderedQuantity
                                ? 'text-danger'
                                : ''
                              : ''
                          }`}
                        >
                          {combinedOrderItem.fulfilledQuantity != null ? combinedOrderItem.fulfilledQuantity : '-'}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="text-right m-b-6">
              {deliveryDayMarketplace.inventoryStatus === DELIVERY_DAY_MARKETPLACE_INVENTORY_STATUS.inProgress ? (
                <button
                  className={`btn btn-success m-r-2 ${editLoading ? 'btn-loading' : ''}`}
                  onClick={() => {
                    editDeliveryDayMarketplace({
                      deliveryDayMarketplace: {
                        ...deliveryDayMarketplace,
                        combinedOrderItems,
                        inventoryStatus: DELIVERY_DAY_MARKETPLACE_INVENTORY_STATUS.complete,
                      },
                    });
                  }}
                >
                  <FormattedMessage id={'packer.delivery.day.marketplace.inventory.cta.complete'} />
                </button>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      ) : (
        <div>
          <FormattedMessage id={'packer.delivery.day.marketplace.inventory.not.created'} />
        </div>
      )}
    </div>
  );
};

PackerDeliveryDayMarketplaceView.propTypes = {
  currentUser: PropTypes.object,
  deliveryDayMarketplace: PropTypes.object.isRequired,
};

PackerDeliveryDayMarketplaceView.defaultProps = {};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser.user,
  };
}

export default injectIntl(connect(mapStateToProps)(PackerDeliveryDayMarketplaceView));
